import {
  parseAgeValue,
  toPositiveNumber,
  type DdeDrugInput,
  type DdeIndicationInput,
} from './ddeRows'

export const POLICY_INDICATION_EDIT_TYPE = {
  Age: 'Age',
  Diagnosis: 'Diagnosis',
  Frequency: 'Frequency',
  MaxDailyUnits: 'MaxDailyUnits',
  MaxUnitsOverTime: 'MaxUnitsOverTime',
} as const

export type PolicyIndicationEditType = keyof typeof POLICY_INDICATION_EDIT_TYPE

export const drugEditTypeLabels: { [key in PolicyIndicationEditType]: string } =
  {
    Age: 'Age',
    Diagnosis: 'Diagnosis',
    Frequency: 'Frequency',
    MaxDailyUnits: 'Max Units Per Day',
    MaxUnitsOverTime: 'Max Units Over Time',
  } as const

export const formatDrugPolicyName = (
  drug: DdeDrugInput,
  indicationType: PolicyIndicationEditType,
) => {
  const drugName = drug.rialticDrugName ?? `${drug.brandName} (${drug.genericName})`
  return `${drugName} - ${drugEditTypeLabels[indicationType]}`
}

export const parseIndicationTypes = (
  indication: DdeIndicationInput,
): PolicyIndicationEditType[] => {
  const types: PolicyIndicationEditType[] = []
  const ageMin = parseAgeValue(indication.ageMin)
  const ageMax = parseAgeValue(indication.ageMax)

  if (ageMin !== undefined || ageMax !== undefined) {
    types.push(POLICY_INDICATION_EDIT_TYPE.Age)
  }
  if (indication.icd10Codes?.length) {
    types.push(POLICY_INDICATION_EDIT_TYPE.Diagnosis)
  }
  if (toPositiveNumber(indication.frequencyMaxAdminDays) !== undefined) {
    types.push(POLICY_INDICATION_EDIT_TYPE.Frequency)
  }
  if (toPositiveNumber(indication.maxDailyHcpcsUnits) !== undefined) {
    types.push(POLICY_INDICATION_EDIT_TYPE.MaxDailyUnits)
  }
  if (
    toPositiveNumber(indication.maxUnitsOverTimeMaxHCPCSUnits) !== undefined
  ) {
    types.push(POLICY_INDICATION_EDIT_TYPE.MaxUnitsOverTime)
  }
  return types
}
